import { postAction } from './request'

/**
 * 获取订单列表
 * @param {*} params
 * @returns
 */
export async function getOrderList(pageNow) {
  return postAction('/cms/order/orderList', { status: '-1', orderType: 0, pageSize: 20, pageNow })
}

/**
 * 获取收藏列表
 * @param {*} params
 * @returns
 */
export async function getFavoriteGoodsList(pageNow) {
  return postAction('/gw/goodsWish/query', { pageSize: 20, pageNow })
}

/**
 * 获取最近查看商品列表
 * @param {*} params
 * @returns
 */
export async function getRecentlyViewedGoodsList(pageNow) {
  return postAction('/cms/recommend/recentlyViewed/query', { pageSize: 20, pageNow })
}

/**
 * 获取购物车信息
 * @param {*} params
 * @returns
 */
export async function getCartInfo(params) {
  return postAction('/gw/cart/get/v2', {
    "queryType": 1,
    ...params
  })
}
